import { jsx as _jsx } from "react/jsx-runtime";
import { Button, Icon } from '@chakra-ui/react';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import useBackButton from '@/hooks/useBackButton';
export default function BackButton(param) {
    var fallbackParams = param.fallbackParams, children = param.children;
    var back = useBackButton(fallbackParams).back;
    return /*#__PURE__*/ _jsx(Button, {
        variant: "link",
        colorScheme: "blue",
        size: "sm",
        color: "textSecondary",
        margin: "none",
        justifyContent: "left",
        width: "fit-content",
        onClick: back,
        leftIcon: /*#__PURE__*/ _jsx(Icon, {
            size: "sm",
            as: FontAwesomeIcon,
            icon: faArrowLeft
        }),
        iconSpacing: 2,
        children: children
    });
}
